
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#fff"}},[_c('path',{attrs:{"d":"M0 41.019l28.565 7.39V1.594L0 8.987V41.02zm14.572-13.864c-3.17-1.54-5.237-3.984-5.237-7.85 0-4.534 2.718-8.006 7.22-8.006 2.154 0 3.737.633 4.871 1.341l-.964 4.851c-.766-.512-2.122-1.26-3.993-1.26-1.868 0-2.775 1.182-2.775 2.564 0 1.696 1.076 2.444 3.538 3.745 3.37 1.736 4.954 4.183 4.954 7.928 0 4.456-2.458 8.239-7.698 8.239-2.182 0-4.332-.786-5.409-1.615l.878-4.969c1.16.827 2.945 1.653 4.787 1.653 1.981 0 3.029-1.14 3.029-2.879-.003-1.652-.91-2.602-3.201-3.742zM43.768 17.87c-1.031 0-1.987.274-2.845.718l-3.788-3.794c.248-.671.4-1.385.4-2.142 0-3.354-2.651-6.066-5.97-6.204v12.413a6.364 6.364 0 001.882-.377l4.255 4.252c-.1.44-.167.895-.167 1.367 0 1.543.582 2.936 1.512 4.022l-3.69 3.69c-.865-.443-1.826-.722-2.86-.722-.316 0-.624.046-.932.092V43.46c.308.048.616.092.933.092a6.227 6.227 0 006.226-6.227 6.1 6.1 0 00-.152-1.347l5.694-5.694C47.472 30.024 50 27.37 50 24.1a6.236 6.236 0 00-6.232-6.23z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h50v50H0z"}})])])])
          )
        }
      }
    